import '../styles/cta/one.scss'
const CTAOne = () => {
  return (
    <div className="cta__one__container">
        <div className="cta__one__wrapper">
            <h1 className='cta__one__text'>Join the team of our experienced traders</h1>
            <span className='cta__one__buttons'>
                <button className='cta__one__button__white'>Learn more</button>
                <button className='cta__one__button__blue'>Get Started</button>
            </span>
        </div>
    </div>
  )
}

export default CTAOne